import '@ezugi/polyfills.js';
import {
  lazy, Suspense, useEffect, useState,
} from 'react';
import { createRoot } from 'react-dom/client';

import { fetchTableConfig } from '@ezugi/bootstrap/src/store/epics/config/fetch';
import { GAME_ID_FROM_URL } from '@ezugi/constants';

import localeGroups from './localeGroups.json';
import { UI_CONFIG } from './uiConfig';
import { REDESIGNED_BACCARAT_GAME_IDS, preventZoom } from './utils';

const BaccaratOld = lazy(() => import('./config-bac'));
const BaccaratNew = lazy(() => import('./config-new-bac'));

const rootElement = document.getElementById('root') as HTMLDivElement;
const root = createRoot(rootElement);

const Baccarat = ({ isNewDesign, timestamps, prefetchTableConfig }: any) => (
  <Suspense>
    {isNewDesign ? (
      <BaccaratNew
        prefetchTableConfig={prefetchTableConfig}
        timestamps={timestamps}
      />
    ) : (
      <BaccaratOld
        prefetchTableConfig={prefetchTableConfig}
        timestamps={timestamps}
      />
    )}
  </Suspense>
);

const BaccaratLoader = () => {
  const [ isLoaded, setIsLoaded ] = useState(false);
  const [ newDesign, setIsNewDesign ] = useState(false);
  const [ initialData, setInitialData ] = useState<any>(undefined);
  const [ timestamps, setTimestamps ] = useState<any>(undefined);

  // eslint-disable-next-line consistent-return
  const getFeatureFlags = async () => {
    let prefetchTableConfig;

    const requestTimestamp = performance.now();
    let responseTimestamp;

    try {
      prefetchTableConfig = await fetchTableConfig({ localeGroups });
      responseTimestamp = performance.now();
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error(error);
    }

    const featureFlags = prefetchTableConfig?.result.config?.feature_flags;
    const hasNewDesign = Boolean(featureFlags?.new_redesign_enabled);

    const defaultConfig = UI_CONFIG;

    setTimestamps({
      performance: {
        initialDataRequest: {
          requestTimestamp,
          responseTimestamp,
        },
      },
    });

    const isNewDesign = REDESIGNED_BACCARAT_GAME_IDS.includes(GAME_ID_FROM_URL)
      && hasNewDesign === true;

    if (isNewDesign === true) {
      Object.assign(UI_CONFIG, defaultConfig, {
        NEW_DESIGN_ENABLED: isNewDesign,
      });
    }

    setIsLoaded(true);
    setInitialData(prefetchTableConfig);
    setIsNewDesign(isNewDesign);
  };

  useEffect(() => {
    getFeatureFlags();

    window.addEventListener('keydown', preventZoom);

    return () => {
      window.removeEventListener('keydown', preventZoom);
    };
  }, []);

  return isLoaded ? (
    <Baccarat
      isNewDesign={newDesign}
      prefetchTableConfig={initialData}
      timestamps={timestamps}
    />
  ) : null;
};

root.render(
  <Suspense>
    <BaccaratLoader />
  </Suspense>
);
